class ProductContactForm extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#ProductContactDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setProductImagesButtonAccessibility();
  }

  setProductImagesButtonAccessibility() {
    const moreImagesButton = document.querySelector('a[href="#productcontactform"]');
    if (!moreImagesButton) return;

    moreImagesButton.setAttribute('role', 'button');
    moreImagesButton.setAttribute('aria-haspopup', 'dialog');
    moreImagesButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(moreImagesButton);
    });
    moreImagesButton.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(moreImagesButton);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('ProductContactDrawer');
        const focusElement = this.querySelector('.product-contact__inner') || this.querySelector('.product-contact__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('product-contact-form', ProductContactForm);
